export function assignRef<T>(
  ref: React.Ref<T | null | undefined>,
  value: T | null,
) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref !== null) {
    (ref as React.MutableRefObject<T | null>).current = value;
  }
}
